/** Tab values for Radix `<Tabs>` (English, stable). URL uses Polish slugs: `zadania` | `problemy`. */

export type SectionDetailTab = 'tasks' | 'issues';
export type PropertyDetailTab = 'work' | 'instructions' | 'warehouse';

export function parseSectionDetailTabParam(raw: string | null): SectionDetailTab {
  if (!raw) return 'tasks';
  const lower = raw.trim().toLowerCase();
  if (lower === 'issues' || lower === 'problemy') return 'issues';
  if (lower === 'tasks' || lower === 'zadania') return 'tasks';
  return 'tasks';
}

export function sectionDetailTabToSearchParam(tab: SectionDetailTab): string {
  return tab === 'issues' ? 'problemy' : 'zadania';
}

export function parsePropertyDetailTabParam(raw: string | null): PropertyDetailTab {
  if (!raw) return 'work';
  const lower = raw.trim().toLowerCase();
  if (lower === 'warehouse' || lower === 'inventory' || lower === 'magazyn') return 'warehouse';
  if (lower === 'instructions' || lower === 'instrukcje') return 'instructions';
  if (lower === 'work' || lower === 'tasks' || lower === 'zadania') return 'work';
  return 'work';
}

export function propertyDetailTabToSearchParam(tab: PropertyDetailTab): string {
  if (tab === 'warehouse') return 'magazyn';
  if (tab === 'instructions') return 'instrukcje';
  return 'zadania';
}
